import React, { Fragment } from 'react'
import { useSelector } from "react-redux";
import { TrafficLightLocationIcon } from './TrafficLightLocationIcon';
import TrafficLightMarkerPopup from './TrafficLightMarkerPopup';
import { selectIntersections } from "../../trafficInfra/trafficInfraSlice";
import { AutoOpenMarker } from "./AutoOpenMarker";

import L from 'leaflet';

const TrafficLightMarkers = ({ routeCoordinates, routeProximity = 20 }) => {
    const intersections = useSelector(selectIntersections);
    let features = intersections?.features;

    if (routeCoordinates && features) {
        features = features.filter(feature => {
            const { geometry } = feature;
            if (!geometry) return false;
            const { coordinates } = geometry;
            // coordinates are [lng, lat] in GeoJSON, but Leaflet uses [lat, lng]
            const markerLatLng = L.latLng(coordinates[0][1], coordinates[0][0]);

            // Check if marker is close to any point on the route
            // Use configurable threshold
            return routeCoordinates.some(coord => markerLatLng.distanceTo(coord) < routeProximity);
        });
    }

    const renderMarker = (feature, index) => {
        const { geometry, properties } = feature;

        if (!geometry) {
            return null;
        }

        const { coordinates } = geometry;
        const { paikka, liva_nro } = properties;
        const position = { lat: coordinates[0][1], lng: coordinates[0][0] };

        return (
            <AutoOpenMarker
                key={`${liva_nro}-${index}`}
                position={position}
                title={paikka}
                icon={TrafficLightLocationIcon}
                autoOpenId={liva_nro}
            >
                <TrafficLightMarkerPopup data={feature} />
            </AutoOpenMarker>
        );
    };

    const markers = features?.map(renderMarker);

    return <>{markers}</>;
};

export default TrafficLightMarkers;
